import { render, staticRenderFns } from "./detailsThirdSupplierSupplyList.vue?vue&type=template&id=18a6f194"
import script from "./detailsThirdSupplierSupplyList.vue?vue&type=script&lang=js"
export * from "./detailsThirdSupplierSupplyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports